module.exports = __webpack_public_path__ + "img/round-navigate_next-24px.9a7e16bb.svg";